// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class DataBaseWorkingClass {
    constructor(databaseName) {
        this.db = null;
        this.DBName = databaseName;
    }
    OpenDB(objectStoreKey, keyPathValue) {
        return __awaiter(this, void 0, void 0, function* () {
            this.db = yield this.CreateObjectStore(objectStoreKey, keyPathValue);
            return this.db !== null;
        });
    }
    getDBLastVersion() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new Promise((resolve) => {
                const openRequest = indexedDB.open(this.DBName);
                openRequest.onerror = function () {
                    resolve(1);
                };
                openRequest.onsuccess = function () {
                    openRequest.result.close();
                    resolve(openRequest.result.version);
                };
            });
        });
    }
    isKeyPresent(objectStoreKey, version) {
        return __awaiter(this, void 0, void 0, function* () {
            const checkPromise = new Promise((resolve) => {
                const openRequest = indexedDB.open(this.DBName, version);
                openRequest.onerror = function () {
                    resolve(false);
                };
                openRequest.onsuccess = function () {
                    const isPresent = openRequest.result.objectStoreNames.contains(objectStoreKey);
                    openRequest.result.close();
                    resolve(isPresent);
                };
            });
            const result = yield checkPromise;
            return result;
        });
    }
    CreateObjectStore(objectStoreKey, keyPathValue) {
        return __awaiter(this, void 0, void 0, function* () {
            let version = yield this.getDBLastVersion();
            return yield new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                const isPresent = yield this.isKeyPresent(objectStoreKey, version);
                if (!isPresent) {
                    version++;
                }
                const openRequest = indexedDB.open(this.DBName, version);
                openRequest.onerror = function () {
                    resolve(null);
                };
                openRequest.onsuccess = function () {
                    resolve(openRequest.result);
                };
                openRequest.onupgradeneeded = function () {
                    const db = openRequest.result;
                    if (!db.objectStoreNames.contains(objectStoreKey)) {
                        db.createObjectStore(objectStoreKey, { keyPath: keyPathValue }); // создаем хранилище
                    }
                };
            }));
        });
    }
    GetStorage(objectStoreKey) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.db.transaction(objectStoreKey, 'readwrite').objectStore(objectStoreKey);
        });
    }
    AddToDB(data, objectStoreKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const objectStore = yield this.GetStorage(objectStoreKey);
            return yield new Promise((resolve) => {
                const request = objectStore.put(data);
                request.onsuccess = function () {
                    resolve(request);
                };
                request.onerror = function () {
                    resolve(request);
                };
            });
        });
    }
    // The same content as AddToDB, but name UpdateEntryInDB is necessary for us to distinguish between actions
    // Or some improves
    UpdateEntryInDB(data, objectStoreKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const objectStore = yield this.GetStorage(objectStoreKey);
            return yield new Promise((resolve) => {
                const request = objectStore.put(data);
                request.onsuccess = function () {
                    resolve(request);
                };
                request.onerror = function () {
                    resolve(request);
                };
            });
        });
    }
    GetFromDB(key, objectStoreKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const objectStore = yield this.GetStorage(objectStoreKey);
            return yield new Promise((resolve) => {
                const request = objectStore.get(key);
                request.onsuccess = function () {
                    resolve(request);
                };
                request.onerror = function () {
                    resolve(null);
                };
            });
        });
    }
    GetAllEntriesFromDB(objectStoreKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const objectStore = yield this.GetStorage(objectStoreKey);
            return yield new Promise((resolve) => {
                const request = objectStore.getAll();
                request.onsuccess = function () {
                    resolve(request);
                };
                request.onerror = function () {
                    resolve(null);
                };
            });
        });
    }
    DeleteFromDB(key, objectStoreKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const objectStore = yield this.GetStorage(objectStoreKey);
            return yield new Promise((resolve) => {
                const request = objectStore.delete(key);
                request.onsuccess = function () {
                    resolve(request);
                };
                request.onerror = function () {
                    resolve(null);
                };
            });
        });
    }
    IsOpened() {
        return this.db !== null;
    }
    CloseDB() {
        if (this.db !== null) {
            this.db.close();
            this.db = null;
        }
    }
}
